<template>
<div class="file-browser">
  <Toolbar>
    <div class="selected-files">
      {{ formatPlural(selected.length, "dokument izabran", "dokumenta izabrano", "dokumenta izabrano") }}
    </div>
    <ToolbarButton class="btn-info" title="Obrišite selekciju" v-if="selected.length" @click="selected=[]">
      <i class="fa-solid fa-xmark"></i>
    </ToolbarButton>
    <ToolbarSpacer />
    <ToolbarGroup>
      <ToolbarButton :class="{'btn-select': display=='icon'}" title="Ikonice" @click="display='icon'">
        <i class="fa-solid fa-grip"></i>
      </ToolbarButton>
      <ToolbarButton :class="{'btn-select': display=='list'}" title="Lista" @click="display='list'">
        <i class="fa-solid fa-bars"></i>
      </ToolbarButton>
    </ToolbarGroup>
    <ToolbarGroup>
      <ToolbarButton :class="{'btn-select': sort=='az'}" title="Naziv A-Z" @click="sort='az'">
        <i class="fa-solid fa-arrow-down-a-z"></i>
      </ToolbarButton>
      <ToolbarButton :class="{'btn-select': sort=='za'}" title="Naziv Z-A" @click="sort='za'">
        <i class="fa-solid fa-arrow-up-a-z"></i>
      </ToolbarButton>
      <ToolbarButton :class="{'btn-select': sort=='new'}" title="Najnovije" @click="sort='new'">
        <i class="fa-solid fa-arrow-down-long"></i>
        <i class="fa-solid fa-calendar-days"></i>
      </ToolbarButton>
      <ToolbarButton :class="{'btn-select': sort=='old'}" title="Najstarije" @click="sort='old'">
        <i class="fa-solid fa-arrow-up-long"></i>
        <i class="fa-solid fa-calendar-days"></i>
      </ToolbarButton>
    </ToolbarGroup>
    <ToolbarButton class="btn-primary" title="Nova kategorija" @click="newFolderPopup=true">
      <i class="fa-solid fa-folder-plus"></i>
    </ToolbarButton>
    <ToolbarGroup>
      <ToolbarButton class="btn-primary" title="Dodaj dokumente" @click="startFileUpload">
        <i class="fa-solid fa-upload"></i>
      </ToolbarButton>
      <ToolbarDropdown class="btn-primary last-in-toolbar">
        <ToolbarOption @click="startFileUpload">
          <i class="fa-regular fa-file"></i>
          Dodaj fajlove
        </ToolbarOption>
        <ToolbarOption @click="startFolderUpload">
          <i class="fa-regular fa-folder"></i>
          Dodaj fascikle
        </ToolbarOption>
        <ToolbarOption @click="newLinkPopup=true">
          <i class="fa fa-link"></i>
          Dodaj link
        </ToolbarOption>
      </ToolbarDropdown>
    </ToolbarGroup>
    <ToolbarButton class="btn-danger" title="Obrišite" v-if="selected.length" @click="deleteFiles">
      <i class="fa-solid fa-trash"></i>
    </ToolbarButton>
    <ToolbarButton title="Pomerite ovde" v-if="selected.length" @click="moveHere">
      <i class="fa-solid fa-arrow-turn-down"></i>
    </ToolbarButton>
  </Toolbar>
  <ExtDocList :parent="parentItem" v-model:selected="selected" :sort="sort" :display="display" @openDir="openDir" v-if="!loading" :hasUse="hasUse" />
  <DataPager :pages="1" v-model="page" v-if="!loading" />

  <Popup v-model="newFolderPopup">
    <template v-slot:header>
      <h3>Novi folder</h3>
    </template>
    <FormInput v-model="newFolderName" />
    <template v-slot:actions>
      <a class="btn" href="" @click.prevent="newFolder">Save</a>
    </template>
  </Popup>
  <Popup v-model="newLinkPopup">
    <template v-slot:header>
      <h3>Novi link</h3>
    </template>
    <section class="gen-form-container">
        <div class="gf-row">
          <div class="col-md-12">
            <label>Ime:</label>
            <FormInput v-model="newLinkName" />
          </div>
        </div>
        <div class="gf-row">
          <div class="col-md-12">
            <label>Link:</label>
            <FormInput v-model="newLinkUrl" />
          </div>
        </div>
    </section>
    <template v-slot:actions>
      <a class="btn" href="" @click.prevent="newLink">Save</a>
    </template>
  </Popup>
</div>
</template>

<script>
import api from '@/Util/api';
import { DateTime } from 'luxon';
export default {
  props: ["hasUse"],
  data: ()=>({
    parentItem: null,
    loading: false,
    page: 0,
    selected: [],
    sort: "az",
    display: "list",
    parent: null,
    newFolderPopup: false,
    newFolderName: "",
    newLinkPopup: false,
    newLinkName: "",
    newLinkUrl: "",
  }),
  computed: {
  },
  methods: {
    formatPlural(count, singular, dual, plural) {
      var active=plural;
      if ((count%100)<10 || (count%100)>19) {
        if ((count%10)==1)
          active=singular;
        else if ((count%10)>1 && (count%10)<5)
          active=dual;
      }
      return count+" "+active;
    },
    openDir(newItem) {
      var path=(this.$route.params.path || []).slice();
      if (path[path.length-1].length==36)
        path.pop();
      if (newItem) {
        path.push(newItem.uuid);
      }
      this.$router.replace({name: 'page', params: {path}});
      this.parentItem=newItem;
    },
    async newFolder() {
      var fileDb=api.create("ExtDoc");
      fileDb.type="Folder";
      fileDb.filename=this.newFolderName;
      fileDb.uploaded=DateTime.now().toFormat("yyyy-LL-dd HH:mm:ss");
      fileDb.parent=this.parentItem?.uuid || null;
      this.loading=true;
      this.newFolderPopup=false;
      await fileDb.save();
      this.loading=false;
      this.newFolderName=null;
    },
    async newLink() {
      var fileDb=api.create("ExtDoc");
      fileDb.type="Link";
      fileDb.filename=this.newLinkName;
      fileDb.extlink=this.newLinkUrl;
      fileDb.uploaded=DateTime.now().toFormat("yyyy-LL-dd HH:mm:ss");
      fileDb.parent=this.parentItem?.uuid || null;
      this.loading=true;
      await fileDb.save();
      this.loading=false;

      this.newLinkName="";
      this.newLinkUrl="";
      this.newLinkPopup=false;
    },
    startFileUpload() {
      var fileInput=document.createElement("input");
      fileInput.type="file";
      fileInput.multiple=true;
      fileInput.addEventListener("change", ()=>{
        this.uploadFiles([...fileInput.files]);
      });
      fileInput.click();
    },
    startFolderUpload() {
      var fileInput=document.createElement("input");
      fileInput.type="file";
      fileInput.multiple=true;
      fileInput.webkitdirectory=true;
      fileInput.addEventListener("change", ()=>{
        this.uploadFiles([...fileInput.files]);
      });
      fileInput.click();
    },
    async uploadFiles(files) {
      var parentsCache={};
      var parentForPath=async (path)=>{
        path=String(path || "").replace(/\/?[^/]*$/, "");
        if (path) {
          var folderName=path.replace(/^.*\//, "");
          if (parentsCache[path])
            return parentsCache[path];
          var nextParent=await parentForPath(path);
          var fileDb=(await api.list("ExtDoc", [
            ...nextParent?
              [["parent", "=", nextParent]]:
              [["parent", "IS NULL"]],
            ["filename", "=", folderName],
            ["type", "=", 'Folder'],
          ]))[0];
          if (!fileDb) {
            fileDb=api.create("ExtDoc");
            fileDb.type="Folder";
            fileDb.filename=folderName;
            fileDb.parent=nextParent;
            await fileDb.save();
          }
          parentsCache[path]=fileDb.uuid;
          return fileDb.uuid;
        }
        return this.parentItem?.uuid || null;
      }
      for(var file of files) {
        var fileDb=api.create("ExtDoc");
        fileDb.type="File";
        fileDb.parent=await parentForPath(file.webkitRelativePath);
        this.loading=true;
        await fileDb.save();
        await fileDb.upload(file);
      }
      this.loading=false;
    },
    async moveHere() {
      this.loading=true;
      for(var fileUuid of this.selected) {
        var file=await api.get("ExtDoc", fileUuid);
        if (file) {
          await file.action("move", {target: this.parentItem?.uuid || null});
        }
      }
      this.selected=[];
      this.loading=false;
    },
    async deleteFiles() {
      this.loading=true;
      for(var fileUuid of this.selected) {
        var file=await api.get("ExtDoc", fileUuid);
        if (file) {
          await file.delete();
        }
      }
      this.selected=[];
      this.loading=false;
    },
  },
  watch: {
    parent: {
      async handler() {
        this.parentItem=null;
        if (this.parent) {
          this.loading=true;
          this.parentItem=await api.get("ExtDoc", this.parent);
        }
        this.loading=false;
      },
    },
    "$route.params.path": {
      handler() {
        var lastPath=(this.$route.params.path || []).slice().pop() || "";
        if (lastPath.length!=36) {
          lastPath=null;
        }
        if (this.parent!=lastPath)
          this.parent=lastPath;
      }, immediate: true,
    },
  },
  mounted() {
    console.log(this.$route);
  },
}
</script>
